<template>
    <div v-if="role" class="md-content">
        <toolbar title="Édition du rôle" isSave="true" @save="dataSave" />
        <div class="md-mt-5 md-layout md-gutter md-alignment-top-center">
            <div class="md-layout-item md-size-90 ">
                <div class="md-layout md-alignment-top-right">
                    <md-switch v-model="role.isActive" class="md-primary">Actif</md-switch>
                </div>
            </div>

            <div class="md-layout-item md-size-45 md-small-size-90">
                <md-field :class="$v.role.name|validations">
                    <label for="Name">Nom</label>
                    <md-input name="Name" id="Name" type="text" v-model="role.name" required />
                </md-field>
            </div>
            <div class="md-layout-item md-size-45 md-small-size-90">

                <div class="md-layout md-layout-item md-size-90 ">
                    <h3>Titre</h3>
                </div>
                <label class="md-label">{{role.title}}</label><br>
                <md-field>
                    <label>Description: {{role.description}}</label>
                </md-field>
            </div>
        </div>

        <div class="md-my-5 md-layout md-gutter md-alignment-top-center">
            <div class="md-layout-item md-size-90">
                <md-tabs class="md-transparent">
                    <md-tab id="tab-Permissions" name="tab-Permissions" md-label="Permissions">
                        <rolePermission v-bind:items.sync="role.permissions" />
                    </md-tab>
                    <md-tab id="tab-Users" name="tab-Users" md-label="Usagers">
                        <roleUser v-bind:items.sync="role.users" />
                    </md-tab>
                </md-tabs>
            </div>

            <!-- <div class="md-layout-item md-size-90 md-mt-5 ">
                <label class="md-label">Modifié&nbsp;le:&nbsp;{{role.modifiedOn| YYYYMMDD}} </label>
                <label class="md-label">Par:&nbsp;{{role.modifiedBy}}</label>
            </div> -->
            <div class="md-layout-item md-size-90 md-mt-5 ">
                <label class="md-label">Créé&nbsp;le:&nbsp;{{role.createdOn| YYYYMMDD}} </label>
                <label class="md-label">Par:&nbsp;{{role.createdBy}}</label>
            </div>

        </div>
    </div>
</template>
<style scoped>
    .md-transparent {
        background-color: transparent !important;
    }
</style>

<script>
    import { required, requiredIf, minLength, between } from 'vuelidate/lib/validators'
    import baseToolbar from "@/components/toolbarBase.vue";
    import rolePermission from "./role-permission.vue";
    import roleUser from "./role-user.vue";

    import { beforeRouteLeaveExtension } from '@/mixins/beforeRouteLeaveExtension.js';
    import { apiSecurityExtension } from '@/mixins/apiSecurityExtension.js';
    import { navigateRouteExtension } from '@/mixins/navigateRouteExtension.js';


    export default {
        name: "roleEdit",
        mixins: [beforeRouteLeaveExtension, apiSecurityExtension, navigateRouteExtension],
        data: () => ({
            role: null,
        }),
        watch: {
            role: {
                deep: true,
                handler(role) {
                    if(role != null && role.permissions != null && role.users != null){
                        if (this.$v.$init && !this.$v.$anyDirty) { this.$v.$touch(); }
                        else {  this.$v.$reset(); this.$v.$init = true; }
                    }
                }
            }
        },
        validations: {
            role: {
                name: { required }
            }
        },
        created: function () {
            $App.event.$on("app_hotkey_ctrlS", this.onCtrlS);
        },
        destroyed: function () {
            $App.event.$off("app_hotkey_ctrlS", this.onCtrlS);
        },
        mounted: function () {
            this.dataRead();
        },
        methods: {
            dataRead: async function () {

                let data = await this.SecurityRoleGetById(this.$route.params.id);
                if (data) {
                    this.role = data;
                }
            },
            dataSave: async function () {

                this.$v.$touch()
                if (!this.$v.$invalid) {

                    let data = await this.SecurityRoleSave(this.role);
                    if (data) {
                        this.$v.$reset();
                        this.navigateBack({ name: 'role_List' });
                    }
                }
            },
            onCtrlS: function (e) {
            this.dataSave();
            },
        },

        components: {
            toolbar: baseToolbar,
            rolePermission: rolePermission,
            roleUser: roleUser
        }
    };
</script>